export default __webpack_public_path__ + "4e428146468cc6f8cc5932f36052dbc0.svg";